module.exports = __webpack_public_path__ + "static/media/striped_bar_AERO_hand_tall.56b54501.svg";